import { execOnLoad } from '@general/helpers';
import './look.scss';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initLook = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const sliderContainer = sectionContainer.querySelector('.look__carousel');
  if (!sliderContainer) return;

  new Swiper(sliderContainer, {
    loop: true,
    modules: [Navigation, Pagination],
    navigation: {
      prevEl: sectionContainer.querySelector('.look__carousel-arrow--left'),
      nextEl: sectionContainer.querySelector('.look__carousel-arrow--right'),
    },
    pagination: {
      el: sectionContainer.querySelector('.look__carousel-pagination'),
      clickable: true,
    },
  });
};

execOnLoad(window.dAgency.initLook, '.look__section');
